import { ErrorHandler, Injectable, PLATFORM_ID, Inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import * as Sentry from '@sentry/angular';

const CHUNK_ERROR_PATTERNS = [
  /Failed to fetch dynamically imported module/i,
  /Importing a module script failed/i,
  /Loading chunk \d+ failed/i,
  /ChunkLoadError/i,
  /error loading dynamically imported module/i,
];

const CHUNK_RELOAD_KEY = 'chunk_reload_done';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  private sentryHandler = Sentry.createErrorHandler();

  constructor(@Inject(PLATFORM_ID) private platformId: Object) { }

  handleError(error: any): void {
    const message: string = error?.message || error?.originalError?.message || '';

    const isChunkError = CHUNK_ERROR_PATTERNS.some(pattern => pattern.test(message));

    if (isChunkError && isPlatformBrowser(this.platformId)) {
      if (!sessionStorage.getItem(CHUNK_RELOAD_KEY)) {
        sessionStorage.setItem(CHUNK_RELOAD_KEY, 'true');
        window.location.reload();
        return;
      } else {
        Sentry.withScope(scope => {
          scope.setTag('error_type', 'chunk_load_error_post_reload');
          scope.setExtra('chunk_error_message', message);
          this.sentryHandler.handleError(error);
        });
        return;
      }
    }

    this.sentryHandler.handleError(error);
  }
}
